import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import _ from 'lodash';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import api from '../../utils/api';
import PasswordInput from '../auth/PasswordInput';

const CustomAdressModal = ({
  open,
  onClose,
  handleCustomAddress,
  initialValues
}) => {
  const { t } = useTranslation(['common', 'validation']);
  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };

  const validationSchema = Yup.object().shape({
    address_line1: Yup.string().required(t('validation:required')),
    address_postal_code: Yup.string().required(t('validation:required')),
    address_locality: Yup.string().required(t('validation:required')),
    address_country: Yup.string().required(t('validation:required'))
  });

  const handleFormSubmit = async (values, { setSubmitting }) => {
    handleCustomAddress(values);
  };

  return (
    <Dialog
      className="change-password-modal"
      open={open}
      onClose={handleClose}
      aria-labelledby="password-dialog-title"
      fullWidth
      maxWidth="sm"
    >
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleFormSubmit}
      >
        {({ values, handleChange, isSubmitting, errors, touched }) => (
          <Form className="frontoffice-form">
            <DialogTitle id="password-dialog-title">
              {t('account:additional-address-manually')}
            </DialogTitle>

            <DialogContent>
              <div className="form-group">
                <TextField
                  id="address_line1"
                  name="address_line1"
                  variant="outlined"
                  label={t('account:address_line1')}
                  fullWidth
                  placeholder={t('account:address_line1')}
                  value={values.address_line1}
                  onChange={handleChange}
                  error={touched.address_line1 && !!errors.address_line1}
                  helperText={
                    touched.address_line1 && errors.address_line1
                      ? errors.address_line1
                      : null
                  }
                />
              </div>

              <div className="form-group">
                <TextField
                  id="address_line2"
                  name="address_line2"
                  variant="outlined"
                  label={t('account:additional-address')}
                  fullWidth
                  placeholder={t('account:additional-address-placeholder')}
                  value={values.address_line2}
                  onChange={handleChange}
                  error={touched.address_line2 && !!errors.address_line2}
                  helperText={
                    touched.address_line2 && errors.address_line2
                      ? errors.address_line2
                      : null
                  }
                />
              </div>

              <br></br>
              <Grid container spacing={2} justify="center">
                <Grid item xs={12} sm={12} md={6}>
                  <div className="form-group">
                    <TextField
                      id="address_postal_code"
                      name="address_postal_code"
                      variant="outlined"
                      label={t('account:address_postal_code')}
                      fullWidth
                      placeholder={t('account:address_postal_code')}
                      value={values.address_postal_code}
                      onChange={handleChange}
                      error={
                        touched.address_postal_code &&
                        !!errors.address_postal_code
                      }
                      helperText={
                        touched.address_postal_code &&
                        errors.address_postal_code
                          ? errors.address_postal_code
                          : null
                      }
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <div className="form-group">
                    <TextField
                      id="address_locality"
                      name="address_locality"
                      variant="outlined"
                      label={t('account:address_locality')}
                      fullWidth
                      placeholder={t('account:address_locality')}
                      value={values.address_locality}
                      onChange={handleChange}
                      error={
                        touched.address_locality && !!errors.address_locality
                      }
                      helperText={
                        touched.address_locality && errors.address_locality
                          ? errors.address_locality
                          : null
                      }
                    />
                  </div>
                </Grid>
              </Grid>

              <div className="form-group">
                <TextField
                  id="address_state"
                  name="address_state"
                  variant="outlined"
                  label={t('account:address_state')}
                  fullWidth
                  placeholder={t('account:address_state')}
                  value={values.address_state}
                  onChange={handleChange}
                  error={touched.address_state && !!errors.address_state}
                  helperText={
                    touched.address_state && errors.address_state
                      ? errors.address_state
                      : null
                  }
                />
              </div>

              <div className="form-group">
                <TextField
                  id="address_country"
                  name="address_country"
                  variant="outlined"
                  label={t('account:address_country')}
                  fullWidth
                  placeholder={t('account:address_country')}
                  value={values.address_country}
                  onChange={handleChange}
                  error={touched.address_country && !!errors.address_country}
                  helperText={
                    touched.address_country && errors.address_country
                      ? errors.address_country
                      : null
                  }
                />
              </div>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleClose}>{t('common:cancel')}</Button>

              <Button type="submit" color="primary" disabled={isSubmitting}>
                {t('common:save')}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default CustomAdressModal;
